export default __webpack_public_path__ + "static/media/green_salad.810ab8c9.jpg";